import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import HomePage from "./routes/HomePage";
import SignInPage from "./routes/SignInPage";
import SignUpPage from "./routes/SignUpPage";
import ForgotPasswordPage from "./routes/ForgotPasswordPage";
import ResetPasswordPage from "./routes/ResetPasswordPage";

import RequireAuth from "./components/RequireAuth";
import { AuthProvider } from "./contexts/AuthContext";
import ActivitiesPage from "./routes/ActivitiesPage";
import ActivitiesAnalysisPage from "./routes/ActivitiesAnalysisPage";
import AdminPanelPage from "./routes/admin/AdminPanelPage";
import TimeManagementPage from "./routes/admin/TimeManagementPage.jsx";
import TemplateChecklistManagementPage from "./routes/admin/TemplateChecklistManagementPage.jsx";
import ComissionsPage from "./routes/Comissions";
import ErrorPage from "./routes/ErrorPage";
import FinancesManagementPage from "./routes/FinancesManagementPage.jsx";
import ManagementPage from "./routes/ManagementPage";
import StagesPage from "./routes/StagesPage";
import UnauthorizedPage from "./routes/UnauthorizedPage";
import NewMeetingPage from "./routes/meeting/page.jsx";
import WhatsAppPage from "./routes/WhatsAppPage.jsx";

// Páginas de gestão individual
import ProjectsPage from "./routes/manage/ProjectsPage";
import ProjectEditPage from "./routes/manage/ProjectEditPage";
import IntegratorsPage from "./routes/manage/IntegratorsPage";
import PowerCompaniesPage from "./routes/manage/PowerCompaniesPage";
import PowerCompanyEditPage from "./routes/manage/PowerCompanyEditPage";
import EngineersPage from "./routes/manage/EngineersPage";
import AttorneysPage from "./routes/manage/AttorneysPage";

const ROLES = {
  User: 5050,
  Admin: 2019,
};

export default function AppRoutes() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/signIn" element={<SignInPage />} />
          <Route path="/login" element={<SignInPage />} />
          <Route path="/signUp" element={<SignUpPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route path="*" element={<ErrorPage />} />
        
          <Route
            element={<RequireAuth allowedRoles={[ROLES.User, ROLES.Admin]} />}
          >
            <Route exact path="/" element={<HomePage />} />
            <Route path="/home" element={<HomePage />} />
            <Route path="/finances" element={<FinancesManagementPage />} />
            <Route path="/activities" element={<ActivitiesPage />} />
            
            {/* Rotas de gestão individual (URLs limpas) */}
            <Route path="/projects/:id" element={<ProjectEditPage />} />
            <Route path="/projects" element={<ProjectsPage />} />
            <Route path="/integrators/:id" element={<IntegratorsPage />} />
            <Route path="/integrators" element={<IntegratorsPage />} />
            <Route path="/power-companies/:id" element={<PowerCompanyEditPage />} />
            <Route path="/power-companies" element={<PowerCompaniesPage />} />
            <Route path="/engineers/:id" element={<EngineersPage />} />
            <Route path="/engineers" element={<EngineersPage />} />
            <Route path="/attorneys" element={<AttorneysPage />} />
            
            {/* Rota de gestão antiga (compatibilidade) */}
            <Route path="/manage" element={<ManagementPage />} />
            
            <Route path="/stages" element={<StagesPage />} />
            <Route path="/comissions" element={<ComissionsPage />} />
            <Route path="/meeting" element={<NewMeetingPage />} />
            <Route path="/whatsapp" element={<WhatsAppPage />} />
            <Route path="/unauthorized" element={<UnauthorizedPage />} />
          </Route>

          <Route element={<RequireAuth allowedRoles={[ROLES.Admin]} />}>
            <Route path="/admin-panel" element={<AdminPanelPage />} />
            <Route path="/time-management" element={<TimeManagementPage />} />
            <Route path="/template-checklist" element={<TemplateChecklistManagementPage />} />
            <Route path="/activities-analysis" element={<ActivitiesAnalysisPage />} />
          </Route>

          {/* <Route exact path="/counter" element={<CounterPage />} /> */}
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
